import * as Actions from "./actions";
import { MessagingTabs } from ".";
import { GlobalApplicationState } from "globalApplicationState";

export const setActiveTab = (activeTab: MessagingTabs) => (dispatch, getState: () => GlobalApplicationState) => {
    dispatch(Actions.CreateSetActiveMessagingTab({activeTab}));
}